"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.navigatorDetector = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var navigatorDetector = {
  name: 'navigator',
  lookup: function lookup() {
    var languages = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        languages = (0, _toConsumableArray2.default)(navigator.languages);
      }

      if (navigator.language) {
        languages.push(navigator.language);
      }
    }

    return languages.length > 0 ? languages : undefined;
  }
};
exports.navigatorDetector = navigatorDetector;